import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";

export default function ExperiencesListHero({ count = 8 }: { count?: number }) {
  return (
    <section className="relative min-h-[62vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20several%20green%20farm%20experiences%20in%20rural%20South%20India%2C%20paddy%20fields%2C%20coconut%20groves%20and%20a%20village%20path%20at%20early%20morning%2C%20lush%20green%20tones%2C%20painterly%20stylized%20agricultural%20landscape%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=experiences-list-hero&orientation=landscape"
          width={1920}
          height={1080}
          alt="Farm and village experiences across rural Konaseema"
          title="Rythugaru agri tourism experiences"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Experiences</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            What You Can Do
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Find Your <span className="italic text-accent-300">Farm Experience.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          From a single day in the fields to a full village immersion — filter by who you are
          travelling with, the season you visit, and how much time you have.
        </p>

        <div className="flex flex-wrap gap-x-10 gap-y-5 mt-10">
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              {count}
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Curated Experiences</p>
          </div>
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              8+
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Villages Connected</p>
          </div>
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              4.9
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Average Visitor Rating</p>
          </div>
        </div>
      </div>
    </section>
  );
}